export const environment = {
  production: true,
  contentUrl: '/content',
  cmsUrl: '/admin-api'
};
